var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"u-icon",on:{"click":_vm.click}},[_c('i',{staticClass:"iconfont",class:'icon-' + _vm.name,style:({ color: _vm.color, fontSize: _vm.size })})])}
var staticRenderFns = []

export { render, staticRenderFns }